<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card
          v-if="
            event.id == $route.params.events_id &&
              (!eventRounds ||
                eventRounds.length == 0 ||
                eventRounds[0].events_id == $route.params.events_id)
          "
        >
          <q-card-section>
            <div class="row items-center">
              <div class="col-12">
                <div
                  style="display: inline-block; font-size: 16px; line-height: 10px;"
                  class="text-h6"
                >
                  <q-btn
                    flat
                    @click="
                      $router.push(
                        `/waves/competitions/${$route.params.competitions_id}/events`
                      )
                    "
                  >
                    <q-icon name="mdi-arrow-left"> </q-icon>
                  </q-btn>
                  {{ event.event_name }}
                  <q-btn
                    label="Combined"
                    dense
                    class="bg-primary text-white"
                    flat
                    no-caps
                    v-if="
                      event.combinedEvents && event.combinedEvents.length > 0
                    "
                  >
                    <q-menu>
                      <div
                        class="row no-wrap q-pa-none full-width"
                        style="min-width: 300px; height: 300px"
                      >
                        <ul>
                          <li>
                            <span style="font-size: 14px" class="text-black">
                              {{ event.event_name }}
                            </span>
                          </li>

                          <li
                            v-for="(ce, index) in event.combinedEvents"
                            :key="`${index}_combinedEvent`"
                          >
                            <span style="font-size: 14px" class="text-black">
                              {{ ce.event_name }}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </q-menu>
                  </q-btn>
                  <!-- <span
                    style="
                      font-size: 12px;
                      left: 78px;
                      top: 0px;
                      position: absolute;
                    "
                    class="text-grey"
                    v-if="competition"
                  >
                    {{ competition.competition_name }}
                  </span> -->
                </div>
              </div>
              <!-- <div class="col-12 q-pb-lg">
                <div class="step-wizard" role="navigation">
                  <div class="progress">
                    <div class="progressbar empty"></div>
                    <div
                      :style="`width: ${
                        ((currentStep + 1) / steps.length) * 100
                      }% !important`"
                      ref="progressBar"
                      id="prog"
                      class="progressbar"
                    ></div>
                  </div>
                  <ul class="justify-around">
                    <li
                      ref="registrationStep"
                      :class="{
                        active: currentViewStep >= 0,
                      }"
                    >
                      <button id="step1" @click="setCurrentView(0)">
                        <div class="step">1</div>
                        <div class="title">Registration</div>
                      </button>
                    </li>
                    <li
                      ref="drawLanesStep"
                      :class="{
                        active: currentViewStep >= 1,
                      }"
                    >
                      <button id="step2" @click="setCurrentView(1)">
                        <div class="step">2</div>
                        <div class="title">Draw Lanes</div>
                      </button>
                    </li>
                    <li
                      ref="marshallStep"
                      :class="{
                        active: currentViewStep >= 2,
                      }"
                    >
                      <button id="step3" @click="setCurrentView(2)">
                        <div class="step">3</div>
                        <div class="title">Event in Progress</div>
                      </button>
                    </li>

                  </ul>
                </div>
              </div> -->

              <q-tabs
                v-if="!finalsProgressionSection && !placingsProgressionSection"
                v-model="round_id"
                dense
                no-caps
              >
                <q-tab
                  :name="'registrationStep'"
                  label="Registration"
                  class="text-white"
                  :class="{
                    'bg-positive': event.currentStep > 0,
                    'bg-primary': event.currentStep == 0
                  }"
                />
                <q-tab
                  :name="'drawLanesStep'"
                  label="Draw Lanes"
                  class="text-white"
                  :disable="event.currentStep < 1"
                  :class="{
                    'bg-positive': event.currentStep > 1,
                    'bg-primary': event.currentStep < 2
                  }"
                />
                <q-tab
                  v-for="(round, index) in eventRounds"
                  :key="`tab_${index}`"
                  :name="round.id"
                  :label="
                    round.round_name == 'Final 1'
                      ? 'Final'
                      : round.round_name == 'Heats 1'
                      ? 'Heats'
                      : round.round_name
                  "
                  class="text-white"
                  :class="{
                    'bg-positive': round.roundFinished_at,
                    'bg-primary': !round.roundFinished_at
                  }"
                />
              </q-tabs>

              <div
                v-if="
                  showFinalsProgressionButton &&
                    !finalsProgressionSection &&
                    !placingsProgressionSection &&
                    ((event.combinedEvents &&
                      event.combinedEvents.length != 0 &&
                      currentRound.races &&
                      currentRound.races[0].ce_overallFinal != 1) ||
                      (currentRound &&
                        currentRound.round_name != 'Final' &&
                        currentRound.round_name != 'Final 1')) &&
                    eventRounds &&
                    eventRounds[eventRounds.length - 1] &&
                    eventRounds[eventRounds.length - 1].id == round.id
                "
                class="q-px-md"
              >
                <q-btn
                  v-if="
                    showFinalsProgressionButton && !finalsProgressionSection
                  "
                  @click="finalsProgressionSection = true"
                  class="bg-primary text-white"
                  no-caps
                >
                  Next Stage
                </q-btn>
              </div>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div class="row">
              <div
                class="col-12 mt-0 pt-0"
                :style="
                  `${
                    !disableVirtualScrolling
                      ? 'height: calc(100vh - 210px) !important'
                      : ''
                  }`
                "
              >
                <component
                  :round_id="round_id"
                  :round="round"
                  :finalsProgressionSection="finalsProgressionSection"
                  :placingsProgressionSection="placingsProgressionSection"
                  :showFinalsProgressionButton="showFinalsProgressionButton"
                  :currentRound="currentRound"
                  @enterPreviousRound="enterPreviousRound"
                  ref="currentView"
                  v-bind:is="views[steps[currentViewStep]]"
                  :currentView="steps[currentViewStep]"
                  @closeFinalsProgressionSection="
                    finalsProgressionSection = false
                  "
                  @closePlacingsProgressionSection="
                    placingsProgressionSection = false
                  "
                ></component>
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section class="q-pa-none" style="min-height: 52px">
            <div class="row">
              <div class="col-12 q-pa-sm">
                <q-btn
                  v-if="currentViewStep < 2"
                  no-caps
                  unelevated
                  :disable="currentStep < currentViewStep"
                  color="blue-grey"
                  @click="resetEventProgress()"
                  class="q-ml-lg q-px-xs"
                  :loading="resettingEventLoading"
                  dense
                >
                  Reset
                </q-btn>
                <q-btn
                  class="q-ml-sm"
                  icon="mdi-refresh"
                  color="blue-grey"
                  @click="loadData()"
                  dense
                >
                </q-btn>
                <q-btn
                  v-if="currentViewStep != steps.length && currentStep < 2"
                  no-caps
                  color="primary"
                  class="float-right q-mr-lg q-px-xs"
                  :disable="currentStep != currentViewStep"
                  @click="continueProgress(currentStep + 1)"
                  dense
                  :loading="continueLoading"
                >
                  Continue
                </q-btn>
              </div>
            </div>
          </q-card-section>
        </q-card>
        <q-card v-else>
          <q-card-section>
            <div class="row items-center">
              <div class="col-12">
                <div style="display: inline-block" class="text-h6">
                  <q-btn
                    flat
                    @click="
                      $router.push(
                        `/waves/competitions/${$route.params.competitions_id}/events`
                      )
                    "
                  >
                    <q-icon name="mdi-arrow-left"> </q-icon>
                  </q-btn>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section class="q-pa-none">
            <div class="row">
              <div
                class="col-12 mt-0 q-pa-lg"
                style="height: calc(100vh - 120px) !important"
              >
                <q-skeleton
                  style="width: 90%; height: 90%; margin: auto"
                ></q-skeleton>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import registration from "@/components/wavesProgress/registration.vue";
import drawLanes from "@/components/wavesProgress/drawLanes.vue";
import eventsInProgress from "@/components/wavesProgress/eventsInProgress.vue";
// import marshall from "@/components/wavesProgress/marshall.vue";
// import checkin from "@/components/wavesProgress/checkin.vue";
// import results from "@/components/wavesProgress/results.vue";
// import overallPoints from "@/components/wavesProgress/overallPoints.vue";

// import { Notify } from "quasar";

export default {
  components: {
    registration,
    drawLanes
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      event: "events/current",
      competition: "competitions/current",
      eventRounds: "eventProgress/rounds",
      currentRound: "eventProgress/currentRound",
      disableVirtualScrolling: "settings/disableVirtualScrolling"
    })
  },
  data: () => ({
    // Tabs
    round_id: null,
    round: null,
    finalsProgressionSection: false,
    placingsProgressionSection: false,
    showFinalsProgressionButton: false,

    currentStep: 0,
    currentViewStep: 0,
    steps: [
      "registrationStep",
      "drawLanesStep",
      "eventsInProgressStep",
      "eventsInProgressStep"
    ],
    views: {
      registrationStep: registration,
      drawLanesStep: drawLanes,
      eventsInProgressStep: eventsInProgress
    },
    resettingEventLoading: false,

    continueLoading: false
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    },
    round_id: function() {
      if (
        this.round_id &&
        this.round_id != "registrationStep" &&
        this.round_id != "drawLanesStep"
      ) {
        if (!this.eventRounds || this.eventRounds.length < 1) {
          this.loadEventProgress();
        }
        this.round = this.eventRounds.find(e => e.id == this.round_id);
        this.setCurrentView(2);
      } else {
        let index = this.steps.findIndex(s => s == this.round_id);
        this.setCurrentView(index);
        this.round == null;
      }
    },
    currentStep: function() {
      if (this.currentStep == 0) {
        this.round_id = "registrationStep";
      } else if (this.currentStep == 1) {
        this.$store.dispatch("events/loadByID", this.$route.params.events_id);
        this.round_id = "drawLanesStep";
      } else if (this.currentStep >= 2) {
        // setTimeout(() => {
        this.loadEventProgress();
        // }, 500);
      }
    },
    eventRounds() {
      this.checkIfProgressionAvailable();
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    enterPreviousRound() {
      let idx = this.eventRounds.findIndex(r => r.id == this.round_id);
      this.round_id = this.eventRounds[idx - 1].id;
      this.loadData();
    },
    loadData() {
      this.loadEventProgress();
      this.$store.dispatch(
        "competitions/loadByID",
        this.$route.params.competitions_id
      );
      this.$store.dispatch(
        "events/loadParticipantsForEvent",
        this.$route.params.events_id
      );
      this.$store.dispatch(
        "events/loadRegistrationData",
        this.$route.params.events_id
      );
      this.$store.dispatch("dqCodes/loadAll");
    },

    loadEventProgress() {
      this.$store
        .dispatch("events/loadByID", this.$route.params.events_id)
        .then(() => {
          this.loadEventRounds();

          this.setStep(this.event.currentStep);
        });
    },

    loadEventRounds() {
      this.$store
        .dispatch("eventProgress/loadRounds", this.event.id)
        .then(() => {
          // if (this.eventRounds.length < 1) {
          // setTimeout(() => {
          // this.$store
          //   .dispatch("eventProgress/loadRounds", this.event.id)
          //   .then(() => {
          //     this.initRoundData();
          //   });
          // }, 500);
          // } else {
          this.initRoundData();
          // }
        });
    },

    initRoundData() {
      if (this.event.currentStep >= 2) {
        let round = this.eventRounds.find(e => e.roundFinished_at == null);

        this.round_id = round
          ? round.id
          : this.eventRounds && this.eventRounds[this.eventRounds.length - 1]
          ? this.eventRounds[this.eventRounds.length - 1].id
          : null;

        this.round = round
          ? round
          : this.eventRounds && this.eventRounds[this.eventRounds.length - 1]
          ? this.eventRounds[this.eventRounds.length - 1]
          : null;
      }
    },

    checkIfProgressionAvailable() {
      let finished = 0;
      this.eventRounds.forEach(round => {
        if (round.roundFinished_at) {
          finished += 1;
        }
      });

      if (finished == this.eventRounds.length) {
        this.showFinalsProgressionButton = true;
      } else {
        this.showFinalsProgressionButton = false;
      }
    },

    setCurrentView(idx) {
      if (idx <= this.currentStep) {
        this.currentViewStep = idx;
      }
    },

    async continueProgress(idx) {
      this.continueLoading = true;
      let response = await this.$refs.currentView.updateProgress();
      this.continueLoading = false;
      if (response === false) {
        return;
      }

      if (idx != 3) {
        this.setStep(idx);
      }
    },

    setStep(idx) {
      this.currentStep = idx < 0 ? 0 : idx;
      // this.steps.forEach((val, index) => {
      //   if (index < idx) {
      //     this.$nextTick(() => {
      //       this.$refs[val].classList.add("done");
      //     });
      //   } else if (index == idx) {
      //     this.$nextTick(() => {
      //       this.$refs[val].classList.remove("done");
      //     });
      //   } else {
      //     this.$nextTick(() => {
      //       this.$refs[val].classList.remove("done");
      //     });
      //   }
      // });
      this.setCurrentView(this.currentStep);
    },
    resetEventProgress() {
      this.resettingEventLoading = true;
      this.$store
        .dispatch("events/resetEventProgress", {
          toStep: this.currentViewStep,
          id: this.event.id
        })
        .then(result => {
          this.resettingEventLoading = false;
          if (result.Result == "Success") {
            this.setStep(this.currentStep - 1);
            this.loadData();
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>

<style lang="scss" scoped>
.buttons {
  position: absolute;
  text-align: center;
  width: 100%;
}
.btn {
  width: 50px;
  height: 30px;
}
.step-wizard {
  display: inline-block;
  position: relative;
  width: 100%;
  .progress {
    position: absolute;
    width: 100%;
  }
  .progressbar {
    position: absolute;
    background-color: $primary;
    opacity: 1;
    height: 3px;
    //border: 1px solid e5e6e6;
    width: 0%;
    -webkit-transition: width 0.6s ease;
    -o-transition: width 0.6s ease;
    transition: width 0.6s ease;
    &.empty {
      opacity: 1;
      width: 100%;
      background-color: #d0d0d0;
    }
  }
  ul {
    position: absolute;
    width: 100%;
    list-style-type: none;
    padding: 0;
    display: flex;
    list-style: none;
    margin: 0px;
    top: -15px;
  }
  li {
    display: inline-block;
    text-align: center;
    & .step {
      text-align: center;
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 3px solid;
      border-color: #d0d0d0;
      background: #ffffff;
      -webkit-transition: background-color 0.6s ease, border-color 0.6s ease;
      -o-transition: background-color 0.6s ease, border-color 0.6s ease;
      transition: background-color 0.6s ease, border-color 0.6s ease;
    }
    & .title {
      width: 100%;
      padding-top: 10px;
      color: #767676;
      -webkit-transition: color 0.6s ease;
      -o-transition: color 0.6s ease;
      transition: color 0.6s ease;
    }
    &.active {
      .step {
        border-color: $primary;
        color: $primary;
      }
      .title {
        text-decoration: none;
        color: $primary;
        font-weight: bold;
      }
    }
    &.done .title {
      color: $primary;
      font-weight: bold;
      &:hover {
        color: $primary;
      }
    }
    &.done .step {
      color: white;
      background-color: $primary;
      border-color: $primary;
    }
    & > button {
      background: none;
      border: none;
      display: block;
      width: 100%;
      color: #777;
      position: relative;
      text-align: center;
      &:hover {
        & .step {
          border-color: $primary;
          background: #eee;
          color: $primary;
        }
        & .title {
          color: $primary;
        }
      }
    }
  }
}

li.done button div.step {
  font-size: 0;
}
li.done button div.step::before {
  content: "\2713 ";
  font-size: 18px;
}
</style>
